import React, { useEffect, useState } from "react";
import { Row, Col, Button, Space, message, Card } from "antd";
import "../../../styles/login.css";
import constants from "../../../constants/constants";
import { useHistory } from "react-router";
import { fetchApi } from "../../../services/api";
import Headers from "../../../header";
import Footers from "../../../footer";
import Book from './Book';
const Unsubscribe = (props) => {
	const history = useHistory();
	const [loading,setLoading]=useState(false);
	const [token,setToken]=useState("");
	const [unsubscribeMessage,setUnsubscribeMessage]=useState("");
	const [button,setButton]=useState(false);
	const location = props.location;
	useEffect(() => {
		const token = props.location.search.substring(1);
		setToken(token);
		if (token) {
			unsubscribe(token, 0); // Initial page load
		}
	}, [location.search]);
	const unsubscribe = (tokenValue = token, flag = 1) => {
		if (!tokenValue) {
			message.error("Invalid token");
			return;
		}
		const payload = {
			token: tokenValue,
			flag,
		};
		setLoading(true);
		fetchApi("/unsubscribe", "post", payload)
			.then((res) => {
				setLoading(false);
				if (res?.code === 200) {
					setButton(flag === 0);
					setUnsubscribeMessage(res.message);
				} else {
					setButton(false);
					setUnsubscribeMessage(res.message);
				}
			})
			.catch(() => {
				setLoading(false);
			});
	};
	return (
		<div>
			<Headers/>
			<div className="login-content flex-vertical-middle">
				<Row gutter={[{
					xs: 8,
					sm: 24,
					md: 48,
					lg: 8,
					xl: 8 
				}, 8]} className="login-px">
					<Book/>
					<Col lg={24} xl={14} className="w-100 flex-middle">
						<div className="text-right signup-link">
							<Space>
								{constants.SignUpRedirect}
								<Button type="link" className="pl-0" onClick={()=>{	history.push("/registration");}}>
									{constants.SignUpRedirectLink}
								</Button>
							</Space>
						</div>
						<div>
							<div className="ml-135">
								{button ? <div><div className="login-form" dangerouslySetInnerHTML={{ __html: unsubscribeMessage, }}/><Space className="mt-2">
									<Button
										shape="round"
										size="large"
										className="gold-btn"
										onClick={() => { history.push("/"); }}
									>
										{constants.CancelBTN}
									</Button>
									<Button
										shape="round"
										size="large"
										className="gold-btn"
										loading={loading}
										onClick={() => unsubscribe(token, 1)}
									>
										{constants.UnsubscribeMe}
									</Button>
								</Space></div>: <Card><div dangerouslySetInnerHTML={{ __html: unsubscribeMessage }}/><div>
									<Button className="btnDb" onClick={()=>history.push("/login")}>{constants.GotoLogin}</Button>
								</div></Card>}
							</div>
						</div>
					</Col>
				</Row>
			</div>
			<Footers/>
		</div>
	);
};
export default Unsubscribe;
